export const STORAGE_KEY = {
  authInfo: 'authInfo',
};
